import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { CheckCircle2 } from 'lucide-react';

const Scale = () => {
  const { content } = useLanguage();
  const { scaleData, ui } = content;

  return (
    <section className="py-20 lg:py-32 bg-gradient-to-b from-black via-gray-950 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
              {scaleData.title}
            </h2>
            <p className="text-lg text-gray-400 mb-8 leading-relaxed">
              {scaleData.description}
            </p>

            {/* Features Grid */}
            <div className="grid sm:grid-cols-2 gap-6">
              {scaleData.features.map((feature) => (
                <div key={feature.id} className="flex items-start">
                  <CheckCircle2 className="text-blue-400 flex-shrink-0 mr-3 mt-1" size={20} />
                  <div>
                    <h4 className="text-white font-semibold mb-1">
                      {feature.title}
                    </h4>
                    <p className="text-gray-400 text-sm">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src={scaleData.image}
                alt={ui.scale.imageAlt}
                className="w-full h-auto object-cover rounded-2xl"
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-blue-600/20 to-transparent"></div>
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-6 bg-blue-600 text-white px-6 py-4 rounded-2xl shadow-2xl">
              <div className="text-2xl font-bold">{ui.scale.badgeTitle}</div>
              <div className="text-sm text-blue-100 mt-1">{ui.scale.badgeSubtitle}</div>
            </div>

            {/* Glow effects */}
            <div className="absolute -top-4 -right-4 w-64 h-64 bg-blue-600/20 rounded-full blur-3xl -z-10"></div>
            <div className="absolute -bottom-4 -left-4 w-64 h-64 bg-blue-800/20 rounded-full blur-3xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Scale;
